import { render, staticRenderFns } from "./badgeRank.vue?vue&type=template&id=3821757e&scoped=true"
import script from "./badgeRank.vue?vue&type=script&lang=js"
export * from "./badgeRank.vue?vue&type=script&lang=js"
import style0 from "./badgeRank.vue?vue&type=style&index=0&id=3821757e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3821757e",
  null
  
)

export default component.exports